/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Utils.Array
 */

module.exports = {

    FindClosestInSorted: require('./FindClosestInSorted'),
    GetRandomElement: require('./GetRandomElement'),
    NumberArray: require('./NumberArray'),
    NumberArrayStep: require('./NumberArrayStep'),
    QuickSelect: require('./QuickSelect'),
    Range: require('./Range'),
    RemoveRandomElement: require('./RemoveRandomElement'),
    RotateLeft: require('./RotateLeft'),
    RotateRight: require('./RotateRight'),
    Shuffle: require('./Shuffle'),
    SpliceOne: require('./SpliceOne')

};



//////////////////
// WEBPACK FOOTER
// ./utils/array/index.js
// module id = 978
// module chunks = 0